import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { ICustomer } from "../models/customer";
import { toast } from "react-toastify";
import agent from "../api/agent";

configure({ enforceActions: "always" });

class CustomerStore {
  @observable customerResgistry = new Map();
  @observable customer: ICustomer | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @computed get customersByName() {
    return Array.from(this.customerResgistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @action loadCustomers = async () => {
    this.loadingInitial = true;
    try {
      const customers = await agent.Customers.list();
      runInAction("loading customers", () => {
        customers.forEach((customer) =>
          this.customerResgistry.set(customer.id, customer)
        );
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load Customer List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load Customer List Error");
    }
  };

  @action loadCustomer = async (id: string) => {
    let customer = this.getCustomer(id);
    if (customer) {
      this.customer = customer;
      return customer;
    } else {
      this.loadingInitial = true;
      try {
        customer = await agent.Customers.details(id);
        runInAction("getting customer", () => {
          this.customer = customer;
          this.loadingInitial = false;
        });
        return customer;
      } catch (error) {
        runInAction("get customer error", () => {
          this.loadingInitial = false;
        });
        toast.error("get customer error");
      }
    }
  };

  @action clearCustomer = () => {
    this.customer = null;
  };

  getCustomer = (id: string) => {
    return this.customerResgistry.get(Number(id));
  };

  @action createCustomer = async (customer: ICustomer) => {
    this.submitting = true;
    try {
      customer.createdAt = new Date().toJSON();
      customer.updatedAt = new Date().toJSON();
      await agent.Customers.create(customer);
      runInAction("create Customer", () => {
        this.submitting = false;
      });
    } catch (error) {
      runInAction("create Customer Error", () => {
        this.submitting = false;
      });
      toast.error("create Customer Error");
      console.log(error);
    }
  };

  @action editCustomer = async (customer: ICustomer) => {
    this.submitting = true;
    try {
      await agent.Customers.update(customer);
      runInAction("editing customer", () => {
        this.customerResgistry.set(customer.id, customer);
        this.customer = customer;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("edit customer error", () => {
        this.submitting = false;
      });
      toast.error("edit customer error");
      console.log(error);
    }
  };

  @action deleteCustomer = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.Customers.delete(id);
      runInAction("deleting Customer", () => {
        this.customerResgistry.delete(id);
        this.submitting = false;
        this.target = "";
      });
    } catch (error) {
      runInAction("edit customer error", () => {
        this.submitting = false;
        this.target = "";
      });
      toast.error("edit customer error");
      console.log(error);
    }
  };
}

export default createContext(new CustomerStore());
